import { makeStyles } from '@material-ui/core'
import { BASE_COLORS } from 'asterX-UI/colors.constant'
import { MODAL_STYLES } from 'asterX-UI/theme.constant'

export const useModalStyles = makeStyles(theme => ({
  paper: {
    backgroundColor: '#F8F8F8'
  }
}))

export const modalTitleIconedStyles = theme => ({
  root: {
    margin: 0,
    position: 'relative',
    padding: '12px 12px 6px 12px',
    display: 'flex',

    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  title: {
    fontWeight: 600
  },
  icon: { display: 'flex', gap: 10, alignItems: 'center' },
  closeButton: {}
})

export const modalTitleStyles = theme => ({
  root: {
    margin: 0,
    position: 'relative',
    padding: '12px 12px 6px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  closeButton: {}
})
